var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreSectionBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 716,
    viewBox: "0 0 1440 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 716,
    fill: "#6587FA",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 633,
    cy: 243,
    r: 159,
    fill: "#6587FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 420,
    cy: 403,
    r: 29,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 1187,
    cy: 178,
    r: 29,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 161,
    cy: 490,
    r: 11,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 484,
    cy: 98,
    r: 13,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 1121,
    cy: 300,
    r: 227,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 661,
    cy: 330,
    r: 137,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 307.5,
    cy: 210.5,
    r: 60.5,
    fill: "#6587FA"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 1144.5,
    cy: 210.5,
    r: 60.5,
    fill: "#6587FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreSectionBg);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI3MTYiIHZpZXdCb3g9IjAgMCAxNDQwIDcxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjcxNiIgZmlsbD0iIzY1ODdGQSIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC4wNSIgY3g9IjYzMyIgY3k9IjI0MyIgcj0iMTU5IiBmaWxsPSIjNjU4N0ZBIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjQyMCIgY3k9IjQwMyIgcj0iMjkiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMyIgY3g9IjExODciIGN5PSIxNzgiIHI9IjI5IiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGNpcmNsZSBvcGFjaXR5PSIwLjMiIGN4PSIxNjEiIGN5PSI0OTAiIHI9IjExIiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGNpcmNsZSBvcGFjaXR5PSIwLjA1IiBjeD0iNDg0IiBjeT0iOTgiIHI9IjEzIiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIxMTIxIiBjeT0iMzAwIiByPSIyMjciIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMSIgY3g9IjY2MSIgY3k9IjMzMCIgcj0iMTM3IiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIzMDcuNSIgY3k9IjIxMC41IiByPSI2MC41IiBmaWxsPSIjNjU4N0ZBIi8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMDUiIGN4PSIxMTQ0LjUiIGN5PSIyMTAuNSIgcj0iNjAuNSIgZmlsbD0iIzY1ODdGQSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };